module.exports = __webpack_public_path__ + "img/domestic-1986-annual-meeting.1c0b6d22.jpg";